import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=5e37810f&scoped=true"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionPlan.vue?vue&type=style&index=0&id=5e37810f&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e37810f",
  null
  
)

export default component.exports